@if (invoiceResult$ | async; as invoiceResult) {
  <div class="col-lg-12 p-0 invoice-list">
    @if (sorts$ | async; as sorts) {
      @if (paginate$ | async; as paginate) {
        <div class="row d-flex justify-content-end">
          @if (invoiceResult.length > 0) {
            <div class="col-sm-12 col-md-6 col-lg-5 justify-content-start mt-3" >
              <kn-br-browsing [paginate]="paginate" [recordsShown]="invoiceResult.length"
                recordType="{{ 'label.invoices' | cxTranslate }}">
              </kn-br-browsing>
            </div>
          }
          @if (invoiceResult.length > 0) {
            <div class="col-sm-12 col-md-6 col-lg-7 d-flex justify-content-end">
              <div class="mt-3 pt-1 mr-2">Sort By</div>
              <cx-sorting class="w-40" [sortOptions]="sorts" [sortLabels]="getSortLabels() | async"
                (sortListEvent)="changeSortCode($event)" [selectedOption]="sortType"
                placeholder="{{ 'invoiceResult.sortByMostRecent' | cxTranslate }}">
              </cx-sorting>
              @if (documentNumbers.length) {
                <button type="button" class="w-60 btn btn-outline-primary mr-3" (click)="downloadPdfOrNavigateToDetails(true)">
                  <i class="fas fa-download" aria-hidden="true"></i>
                  {{ 'invoiceResult.header.downloadPDF' | cxTranslate }} &nbsp;
                </button>
              }
              <button type="button" class="w-60 btn btn-primary" [disabled]="downloadProgress" (click)="downloadInvoice()">
                {{ 'invoiceResult.header.downloadStatement' | cxTranslate }} &nbsp; <i class="fas fa-download pr-2" aria-hidden="true"></i>
              </button>
            </div>
          }
        </div>
      }
    }
    @if (invoiceResult && invoiceResult.length) {
      <div class="row counter-wrapper">
        <div class="customersearch-list-table float-left col-lg-12 mt-3">
          <div class="customersearch-list-titles border-top float-left w-100 pl-2 pr-2 pt-3 pb-3 d-none d-sm-none d-lg-block">
            <div class="col-md-1 float-left">
              <p></p>
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.documentType' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.customerNumber' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.soldToCity' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.purchaseOrder' | cxTranslate }}
            </div>
            <div class="col-md-2 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.jobName' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.document' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.documentDate' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.amount' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.dueDate' | cxTranslate }}
            </div>
            <div class="col-md-1 float-left font-text-400 pl-0 font-md-size">
              {{ 'invoiceResult.header.status' | cxTranslate }}
            </div>
          </div>
          @for (invoice of this.invoiceList; track invoice) {
            <div class="bg-white customersearch-list-titles table-content border-top float-left w-100 p-1 font-weight-normal align-items-center">
              <div class="col-md-1 float-left pl-0">
                <div class="form-check-inline mr-0">
                  <input type="checkbox" class="form-check-input" (change)="select(invoice, $event.target.checked)" [checked]="this.documentNumbers.includes(invoice.documentNumber)"/>
                </div>
                <button (click)="downloadPdfOrNavigateToDetails(true, invoice)" type="button" class="btn font-lg-size pl-0">
                  <i class="fas fa-download downloadIcon" aria-hidden="true"></i>
                </button>
              </div>
              <div class="col-md-1 float-left pl-0 mt-3">
                <span>{{ invoice.documentType?.name }}</span>
              </div>
              <div class="col-md-1 float-left pl-0 mt-3 right-align">
                <span>{{ invoice?.accountNumber }}</span>
              </div>
              <div class="col-md-1 float-left pl-0 mt-3">
                <span>{{ invoice?.city }}</span>
              </div>
              <div class="col-md-1 float-left title-wrap pl-0 mt-3 font-md-size color-font" (click)="downloadPdfOrNavigateToDetails(false, invoice)">
                {{ invoice.purchaseOrder }}
              </div>
              <div class="col-md-2 float-left title-wrap pl-0 mt-3 font-md-size color-font" (click)="downloadPdfOrNavigateToDetails(false, invoice)">
                {{ invoice.jobName ? invoice.jobName: '-' }}
              </div>
              <div class="col-md-1 float-left title-wrap pl-0 mt-3 pb-1 font-md-size color-font right-align" (click)="downloadPdfOrNavigateToDetails(false, invoice)">
                <a href="javascript:void(0)" class="cx-link"> {{ invoice.documentNumber | removeLeadingZeros }}</a>
              </div>
              <div class="col-md-1 float-left title-wrap pl-0 mt-3 font-md-size color-font" (click)="downloadPdfOrNavigateToDetails(false, invoice)">
                {{ invoice.invoiceDate }}
              </div>
              <div class="col-md-1 float-left title-wrap pl-0 mt-3 font-md-size color-font right-align" (click)="downloadPdfOrNavigateToDetails(false, invoice)">
                {{ invoice.formattedAmount }}
              </div>
              <div class="col-md-1 float-left title-wrap pl-0 mt-3 font-md-size color-font" (click)="downloadPdfOrNavigateToDetails(false, invoice)">
                {{ invoice.knbrDueDate }}
              </div>
              <div class="col-md-1 float-left title-wrap pl-0 mt-3 font-md-size color-font" (click)="downloadPdfOrNavigateToDetails(false, invoice)">
                {{ invoice.status | titlecase }}
              </div>
            </div>
          }
        </div>
        <div class="col-lg-12 d-flex">
          @if (paginate$ | async; as paginate) {
            <div class="col-lg-6 justify-content-start mt-3" >
              <kn-br-browsing [paginate]="paginate" [recordsShown]="invoiceResult.length" recordType="{{ 'label.invoices' | cxTranslate }}"></kn-br-browsing>
            </div>
            <div class="col-lg-6 w-100 mt-3">
              @if (paginate.currentPage < paginate.totalPages - 1 && !(isLoader$ | async)) {
                <div
                  (click)="loadMore(paginate.currentPage)" class="btn btn-block btn-action align-btn show-more-product font-size border-0 float-left w-auto mt-0 mr-3 btn-loadmore">
                  {{ 'invoiceResult.showMore' | cxTranslate }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (invoiceResult && invoiceResult.length < 1 && !(isLoader$ | async)) {
      <div class="alert-info p-3 rounded mt-3">
        {{ 'invoiceResult.nodataMsg' | cxTranslate }}
      </div>
    }
  </div>
}
@if (downloadProgress) {
  <ng-container class="cx-spinner">
    <cx-spinner class="cx-dialog-popover-center-backdrop"></cx-spinner>
  </ng-container>
}
